import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { AppConfig } from 'src/app/app.config';
import { HelpersService, ServiceRequestService } from 'src/app/services';
import { JobcardService } from 'src/app/services/jobcard.service';

@Component({
  selector: 'app-workshop-jobcard-audit-logs',
  templateUrl: './workshop-jobcard-audit-logs.component.html',
  styleUrls: ['./workshop-jobcard-audit-logs.component.scss']
})
export class WorkshopJobcardAuditLogsComponent {

  @Input() jobcard: any;
  @Output() jobcardChange = new EventEmitter<any>();

  public timerLogs: any[] = [];
  public loading: boolean = true;
  public countryData: any = this.helpersService.getCountryData();

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private helpersService: HelpersService,
    private appConfig: AppConfig,
    private serviceRequest: ServiceRequestService,
    private jobcardService: JobcardService,
  ) { }

  ngOnInit() {
    this.getJobCardTimerAuditTrail();
  }

  getJobCardTimerAuditTrail() {
    this.loading = true;
    this.jobcardService.getServiceSpecificTimers(this.jobcard.partnerID, this.jobcard.id).subscribe((timers: any[]) => {
      this.timerLogs = timers.sort((a, b) =>
        new Date(b.startTime).getTime() - new Date(a.startTime).getTime()
      );
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  // Format duration in seconds to HH:MM:SS
  formatDuration(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(secs)}`;
  }

  // Helper to pad single digits with zero
  padZero(num: number): string {
    return num.toString().padStart(2, '0');
  }

  // Format date/time for display
  formatDateTime(utcDateTime: string): string {
    if (!utcDateTime) return '-';
    const date = new Date(utcDateTime + 'Z');
    return moment(date).format(this.countryData.momentDateFormat + ' h:mm a' );
  }

  // Get total duration across all timer logs
  getTotalDuration(): string {
    const total = this.timerLogs.reduce((sum, log) => sum + (log.durationSeconds || 0), 0);
    return this.formatDuration(total);
  }

  // Check if timer is still active (no end time)
  isActiveTimer(log: any): boolean {
    return !log.endTime;
  }
}
